"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RageAbilityHandler = exports.RageActorAbilityFactory = exports.RageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class RageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Rage;
        this.__typeName = "Rage";
    }
}
exports.RageAbilityArgs = RageAbilityArgs;
let RageActorAbilityFactory = class RageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Rage", "AllEnemies", 2);
    }
};
RageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Rage")
], RageActorAbilityFactory);
exports.RageActorAbilityFactory = RageActorAbilityFactory;
let RageAbilityHandler = class RageAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const target = container.testAttribute(ability.invokerId, "Luck", 5) ? Target_1.Target.AllAllies
            : Target_1.Target.AllEnemies;
        container.applyProjectileAttacksWithDamage({
            sequence: sequence.pushSequence("sequential"),
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: container.selectLivingTargets(ability.invokerId, target)
                .map(targetId => ({
                targetId,
                path: "line",
                type: "GhostlyMissle",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 120)
                ]
            })),
            onHit(sequence, _attack, _damages, { targetId }) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: targetId,
                    effect: new __1.StunEffectArgs(),
                    duration: Duration_1.Duration.Turns(1),
                    onApplied(sequence) {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "DarkLightning"));
                    }
                });
            }
        });
    }
};
RageAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Rage)
], RageAbilityHandler);
exports.RageAbilityHandler = RageAbilityHandler;
